import React from 'react';

// Icons
import DiaryIcon from '../../images/diary-icon.svg';
import AnnouncementIcon from '../../images/announcement-icon.svg';
import EventIcon from '../../images/event-icon.svg';
import ReportIcon from '../../images/report-icon.svg';

// Models
import { BaseContentContainerFormat } from '../../models/base-content-container';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import FeatureTitle from '../../components/feature-title/feature-title';
import QuickAction from '../../components/quick-action/quick-action';

// Services
import StorageService from '../../services/storage-service';

function Home() {
  const storageService = new StorageService();
  const employee = storageService.getEmployee();
  const name = employee ? employee.name : '';

  const quickActionButtons: QuickActionButton[] = [
    {
      icon: DiaryIcon,
      label: 'preencher diários',
      path: '/diarios/listar',
    },
    {
      icon: AnnouncementIcon,
      label: 'criar novo comunicado',
      path: '/comunicados/criar',
    },
    {
      icon: EventIcon,
      label: 'criar novo evento',
      path: '/eventos/criar',
    },
  ];

  if (employee?.role === 'Administrator') {
    quickActionButtons.push({
      icon: ReportIcon,
      label: 'gerar relatório',
      path: '/relatorios/listar',
    });
  }

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.doubleUpperAndLargeBottom}
    >
      <FeatureTitle title={`olá, ${name}`} />
      <QuickAction title='ações rápidas' buttons={quickActionButtons} />
    </BaseContentContainer>
  );
}

export default Home;
